import { JSX } from 'solid-js';
import { mergeClasses } from '@trimble/dom-utils';

/**
 * Render the 'PRO' badge over the child component.
 * Badge is aligned to the top right corner by default
 */
export const Badge = (props: {
  children: JSX.Element;
  ref: HTMLDivElement;
  className?: string;
  preserveWidth?: boolean;
  style?: JSX.CSSProperties;
}): JSX.Element => {
  return (
    <div
      ref={props.ref}
      class={mergeClasses(
        `mr-[0.75rem] flex ${props.preserveWidth ? 'relative' : ''}`,
        props.className
      )}
      style={props.style}
    >
      {props.children}
      <div
        class={mergeClasses(
          `${props.preserveWidth ? 'absolute right-[-0.8em] top-[-0.8em]' : '*:relative  *:right-[0.5em]'} *:top-[-0.5em]`,
          props.className
        )}
      >
        <modus-badge color="dark" size="small" type="counter">
          PRO
        </modus-badge>
      </div>
    </div>
  );
};
